<script>
import AdminLayout from '@layouts/admin-main'
import RealnameList from '@components/admin/kyc-realname-list'

export default {
  page: {
    title: 'Admin::KycRealnameList',
    meta: [{ name: 'description', content: 'Admin::KycRealnameList' }],
  },
  components: { AdminLayout, RealnameList },
}
</script>

<template>
  <AdminLayout>
    <RealnameList></RealnameList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
